import React from 'react';
import { connect } from 'react-redux';
import InfoTooltip from '../../common/tooltip/info/index';
import pdfDownloadContainer from '../../../containers/pdf-download';
import i18next from 'i18next'
class PDFDownload extends React.Component {
  constructor(props) {
    super(props);
    this.handle = this.handle.bind(this);
  }

  async handle() {
    const { request, isDetailedPdf=false } = this.props;
    const employee = request.employee;
    const isEmployeeExist = employee !== undefined;
    const employeeName = isEmployeeExist ? employee.employeeName : this.props.employeeName;

    const data = { id: request._id, employeeName}
    if(isDetailedPdf){
      this.props.downloadDetail({...data})
    }else {
      this.props.download({...data});
    }      
    
  }

  render() {
    if (this.props.canDownload) {
      return (
        <div style={{ display: 'inline' }}>
          <InfoTooltip info='download'>
            <button className="btn btn-xs btn-primary btn-fill" onClick={this.handle}>
             <i className="fa fa-download" />
            </button>
          </InfoTooltip>
        </div>
      );
    }

    return null;
  }
}

export default connect(...pdfDownloadContainer)(PDFDownload);



// WEBPACK FOOTER //
// ./src/components/travel-expense/pdf/index.js